import classNames from 'classnames';
import i18n from '@/settings/i18n';
import { TrustpilotRating } from '@/components/products/TrustpilotWidget';
import TrustpilotStar from './TrustpilotStar';
import { TRUSTPILOT_REVIEW_URL } from '@/lib/trustpilot';
import { useCompanyReviewsContext } from '@/utils/hooks/reviews/useCompanyReviewsContext';
import { formatStoreDecimal, formatStoreNumber } from '@/lib/intl-format';

const t = i18n.init('homepage');

const TrustpilotWidget = ({ className }: { className: string }) => {
  const { company, isLoading } = useCompanyReviewsContext();

  return (
    <a
      href={TRUSTPILOT_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(
        'flex items-center gap-1 text-xs hover:underline',
        className,
      )}
    >
      <TrustpilotRating
        grade={company?.business?.score?.stars ?? 4.7}
        className="h-4 shrink-0"
      />

      <div className="flex items-center gap-1">
        <div className="flex items-center gap-1">
          <span
            className={classNames('font-bold', {
              'blur-sm': isLoading,
            })}
          >
            {formatStoreDecimal(company?.business?.score?.stars ?? 4.7)}
          </span>
          <span className="hidden xxs:inline">{t`out of`} </span>
          <span className="xxs:hidden">/</span>
          <span>5</span>
        </div>
        <div className="hidden items-center gap-1 xs:flex">
          <span>{t`based on`} </span>
          <span
            className={classNames('font-bold', {
              'blur-sm': isLoading,
            })}
          >
            {formatStoreNumber(
              company?.business?.numberOfReviews?.total ?? 90000,
            )}{' '}
            {t`reviews`}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-1">
        <TrustpilotStar height={20} />
        <span className="font-bold">{t`Trustpilot`}</span>
      </div>
    </a>
  );
};

export default TrustpilotWidget;
